<template>
  <el-dialog v-model="visible" title="随便学点啥" width="640px" align-center class="base-modal-wrap"
    :close-on-click-modal="false" :show-close="showClose" @close="handleClose" :label-position="'top'">
    <div class="base-modal-body">
      <div class="custom-course">
        <div class="custom-section">
          <h4 class="section-title">定制专属课程:</h4>
          <el-input v-model="customTopic" placeholder="请输入一个你感兴趣的话题......" class="custom-input" />
        </div>

        <div class="popular-section">
          <h4 class="section-title">大家都在学:</h4>
          <div class="popular-courses">
            <el-button v-for="course in popularCourses" :key="course.id" class="course-tag"
              @click="selectPopularCourse(course)">
              {{ course.name }}
            </el-button>
          </div>
        </div>
      </div>
    </div>

    <template #footer>
      <div class="base-modal-footer text-center mb-8">
        <el-button class="text-[#1a56db]" @click="handleCancel" size="large">取消</el-button>
        <el-button type="primary" @click="handleCreate" size="large" :loading="isCreating">
          创建课程
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { ElMessage } from "element-plus";

const props = defineProps({
  modelValue: Boolean,
  showClose: {
    type: Boolean,
    default: true,
  },
  callBack: {
    type: Function,
    default: () => { },
  }
});

const emits = defineEmits(['update:modelValue', 'create-course']);

const visible = ref(props.modelValue);
const isCreating = ref(false);
const customTopic = ref('');

// 热门课程数据
const popularCourses = ref([
  { id: 1, name: '增长黑客系列课程' },
  { id: 2, name: '人的自由意志是一场幻觉吗?' },
  {
    id: 4, name: 'Python与AI编程入门',
  },
  { id: 3, name: `如何成为“AI超级个体”?` },
  {
    id: 5, name: '数据分析师进阶之路',
  },
  {
    id: 6, name: 'AI工具应用与效率革命',
  },
  {
    id: 7, name: '个人理财与投资入门',
  },
  {
    id: 8, name: '股票投资策略与实战',
  },
  {
    id: 9, name: '情商管理与领导力提升',
  },
  {
    id: 10, name: '时间管理与效率提升',
  },
  {
    id: 11, name: '数字营销与个人IP运营',
  }
]);

// 选择热门课程
const selectPopularCourse = (course: any) => {
  customTopic.value = course.name;
  ElMessage.success(`已选择: ${course.name}`);
};

// 创建课程
const handleCreate = () => {
  if (!customTopic.value.trim()) {
    ElMessage.error('请输入感兴趣的话题');
    return;
  }

  isCreating.value = true;

  // 模拟创建过程
  setTimeout(() => {
    isCreating.value = false;
    emits('create-course', customTopic.value);
    emits('update:modelValue', false);
    ElMessage.success('课程创建成功！');
  }, 1000);
};

watch(() => props.modelValue, (val) => {
  visible.value = val;
  if (val) {
    customTopic.value = ''; // 清空输入
  }
}, { immediate: true });

const handleClose = () => {
  emits('update:modelValue', false);
};

const handleCancel = () => {
  emits('update:modelValue', false);
};
</script>

<style lang="scss">
.base-modal-wrap {
  .el-dialog__header {
    font-size: 18px;
    padding-left: 12px;
    font-weight: 600;
    border-bottom: 1px solid #e5e7eb;
    text-align: left;

    .el-dialog__headerbtn {
      font-size: 20px;
      top: 8px;
      right: 8px;
    }
  }

  .el-dialog__body {
    text-align: left;
    padding: 24px;
  }
}

// 课程定制页面样式
.custom-course {

  .custom-section,
  .popular-section {
    margin-bottom: 24px;

    .section-title {
      font-size: 16px;
      font-weight: bold;
      color: #303133;
      margin: 0 0 12px 0;
      text-align: left;
    }
  }

  .custom-input {
    height: 40px;

    .el-input__wrapper {
      border-radius: 8px;
      font-size: 14px;
      line-height: 1.5;


      &:focus {
        border-color: #409eff;
        box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
      }
    }
  }

  .popular-courses {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;

    .course-tag {
      border: 1px solid #1a56db;
      background: white;
      color: #1a56db;
      border-radius: 20px;
      padding: 12px 16px;
      font-size: 14px;
      transition: all 0.3s ease;
      height: 40px;
      margin: 0;

      &:hover {
        background: #1a56db;
        color: white;
      }
    }
  }
}
</style>
